import { render, staticRenderFns } from "./Switchers.vue?vue&type=template&id=e05828b0&"
import script from "./Switchers.vue?vue&type=script&lang=js&"
export * from "./Switchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports